import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { tailwindVariants } from "@air/tailwind-variants";
import { memo } from "react";
export const breadcrumbsButton = tailwindVariants({
    base: "flex items-center rounded-4 font-medium text-grey-9 outline-none hover:bg-grey-4 hover:text-grey-11 focus-visible:ring-2 focus-visible:ring-blue-9 active:bg-grey-4 active:text-grey-12 ui2:text-grey-11 ui2:hover:bg-grey-3 ui2:active:bg-grey-4",
    variants: {
        size: {
            small: "h-6 gap-1 px-1",
            medium: "h-8 gap-2 px-3",
            large: "h-10 gap-2 px-4"
        }
    },
    defaultVariants: {
        size: "small"
    }
});
export const BreadcrumbsButton = /*#__PURE__*/ memo((param)=>{
    let { children, className, prefix, suffix, ...restOfProps } = param;
    return /*#__PURE__*/ _jsxs("button", {
        "data-testid": "BREADCRUMBS_BUTTON",
        className: breadcrumbsButton({
            class: className
        }),
        ...restOfProps,
        children: [
            !!prefix && /*#__PURE__*/ _jsx("div", {
                className: "shrink-0",
                children: prefix
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "truncate",
                children: children
            }),
            !!suffix && /*#__PURE__*/ _jsx("div", {
                className: "shrink-0",
                children: suffix
            })
        ]
    });
});
BreadcrumbsButton.displayName = "BreadcrumbsButton";
